<style>
  .slider-bar .mat-accent .mat-slider-thumb-label-text::after {
  content: "{{ 'Persons' | translate }}";
}
</style>
<div class="row slider-bar">
  <div class="col-2 col-lg-1">
    <div>
      {{ min }}
      <br>
      <span>min.</span>
    </div>
  </div>
  <div class="col">
    <mat-slider [displayWith]="formatLabel" [max]="inner_max" [min]="inner_min" [step]="1" [thumbLabel]="true" [(ngModel)]="inner_value"></mat-slider>
  </div>
  <div class="col-2 col-lg-1">
    <div>
      {{ max }}
      <br>
      <span>max.</span>
    </div>
  </div>
</div>
